<script setup lang='ts'>
  import { computed } from 'vue'

  import useVideo from '@/composables/useVideo'
  import type { SlideVideo } from '@/types/presentation/SlideVideo'

  import SlideHeading from '@/components/presentation/SlideHeading.vue'
  import SlideText from '@/components/presentation/SlideText.vue'
  import SlideElementPosition from '@/enums/SlideElementPosition'
  import VideoPlayer from '@/components/global/VideoPlayer.vue'

  const props = defineProps<{
    slide: SlideVideo
  }>()

  const { video } = useVideo(parseInt(props.slide.video.destinationContentId))

  const isCentered = computed(() => props.slide.mainElementPosition[0] === SlideElementPosition.Center || !props.slide.mainElementPosition)
</script>

<template>
  <div :class="['slide-video', slide.mainElementPosition]">
    <div :class="['text-column', slide.textPosition]">
      <SlideHeading
        v-if="slide.heading"
        :size="slide.headingFontSize"
        :heading="slide.heading"
      />
      <SlideText
        v-if="slide.text && !isCentered"
        :size="slide.textFontSize"
        :text="slide.text"
      />
    </div>
    <div class="video-column">
      <VideoPlayer
        v-if="video"
        v-bind="video"
      />
    </div>
  </div>
</template>

<style lang='scss' scoped>
  .slide-video {
    display: flex;
    flex-direction: column;
    gap: 40px;
    height: 100%;
    padding: 80px;
    overflow-y: auto;
  }

  .right {
    flex-direction: row;
  }

  .text-column {
    display: flex;
    flex-direction: column;
    max-width: $vgs-max-width-content-large;
    margin: 0 auto;
    gap: 40px;
    width: 100%;
    flex: 1;
  }

  .center-left {
    justify-content: center;
    flex: initial;
  }

  .video-column,
  .text-column {
    display: flex;
    flex-direction: column;
  }

  .video-column {
    flex: 2;
    max-width: $vgs-max-width-content-large;
    margin: 0 auto;
  }
</style>
